import {FileType, ZyusetuType} from "@/graphql/graphql";
import {FileText, Image, FileSpreadsheet} from "lucide-react";

// ファイルタイプごとのパステルカラー定義
export const FILE_TYPE_COLORS: Record<FileType, string> = {
  [FileType.Zumen]: "#E6F7FF", // 薄い青
  [FileType.ZentakuZumen]: "#E6F7FF", // 薄い青
  [FileType.Touki]: "#FFF1E6", // 薄いオレンジ
  [FileType.Mousikomi]: "#F2E6FF", // 薄い紫
  [FileType.Zyusetu]: "#E6FFEF", // 薄い緑
  [FileType.ReinsText]: "#FFE6E6", // 薄い赤
  [FileType.Result]: "#FFFDE6", // 薄い黄色
  [FileType.ManagementBylaw]: "#E6F0FF", // 薄い青紫
  [FileType.ZyusetuResearchReport]: "#FFE6F7", // 薄いピンク
  [FileType.SalesBuildingTouki]: "#E6FFF9", // 薄い水色
  [FileType.SalesLandTouki]: "#F0FFE6", // 薄い黄緑
};

export const FileTypeLabel: Record<FileType, string> = {
  [FileType.Zumen]: "図面(マイソク)",
  [FileType.ZentakuZumen]: "図面(マイソク)",
  
  [FileType.Touki]: "登記",
  [FileType.Mousikomi]: "入居申込・保証会社契約",
  [FileType.Zyusetu]: "重説",
  [FileType.ReinsText]: "Reins掲載情報",
  [FileType.Result]: "結果ファイル",
  [FileType.ManagementBylaw]: "管理規約",
  [FileType.ZyusetuResearchReport]: "重説調査報告書",
  [FileType.SalesBuildingTouki]: "建物登記",
  [FileType.SalesLandTouki]: "土地登記",
};

export interface FileTypeConfig {
  type: FileType;
  icon?: React.ReactNode;
  label?: string;
  sampleImage?: string;
  sampleTitle?: string;
  zyusetuType: ZyusetuType;
  isAvailable?: boolean
}

// ファイルタイプごとのアイコン定義
export const FILE_TYPE_ICONS: Record<FileType, React.ReactNode> = {
  [FileType.Zumen]: <Image size={40} color="#4DABF7"/>,
  [FileType.ReinsText]: <FileText size={40} color="#F03E3E"/>,
  [FileType.ZyusetuResearchReport]: <FileSpreadsheet size={40} color="#F783AC"/>,
  [FileType.Touki]: <FileText size={40} color="#FD7E14"/>,
  [FileType.Mousikomi]: <FileText size={40} color="#9775FA"/>,
  [FileType.Zyusetu]: <FileText size={40} color="#40C057"/>,
  [FileType.Result]: <FileText size={40} color="#FAB005"/>,
  [FileType.ManagementBylaw]: <FileText size={40} color="#4C6EF5"/>,
  [FileType.SalesBuildingTouki]: <FileText size={40} color="#15AABF"/>,
  [FileType.SalesLandTouki]: <FileText size={40} color="#82C91E"/>,
  [FileType.ZentakuZumen]: <Image size={40} color="#4DABF7"/>,
};